import { OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { CreditCard } from '@/config/types';

export const findCreditCardOnboardingDetailsByRole = ({
  creditCard,
  role,
}: {
  creditCard: CreditCard;
  role: OnboardingDetailsRole;
}) => {
  switch (role) {
    case OnboardingDetailsRole.BORROWER:
      return creditCard.borrower;
    case OnboardingDetailsRole.CO_BORROWER:
      return creditCard.coBorrower;
    default:
      return null;
  }
};
